<ng-template #alert let-modal>
  <div class="row">
    <div class="col-sm-12">
      <div class="card">
        <div class="card card-header"></div>
        <div class="card card-body">
          <span style="font-size: 16pt">
            {{modalText}}
          </span>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<div class="inquiry-shell" fxLayout="column" #inquiryShell [style.height.px]="shellHeight">
  <div class="inquiry-shell__header">
    <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
      <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
        <mat-card [style.background-color]="uiData.color" fxFlex="100">
          <h2 class="noMarginHeader">
            <mat-icon>{{uiData.icon}}</mat-icon> {{'Call Tracker Inquiries'}}
          </h2>
        </mat-card>
      </div>
    </div>
  </div>

  <div class="inquiry-shell__content">
  <div *ngIf="!showSearch" fxLayout="Column">
      <mat-card>
        <div class="row">
          <div class="col-sm-12">
            <form [formGroup]="callForm" (ngSubmit)="submitInquiry()">
              <div class="card">
                <div class="card card-body py-1">
                  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="16px">
                    <!-- Call ID -->
                    <mat-form-field fxFlex="20">
                      <mat-label>Call ID</mat-label>
                      <input matInput [value]="callForm.value.callId" readonly class="readonly-input">
                    </mat-form-field>

                    <!-- Employee -->
                    <mat-form-field fxFlex="40">
                      <mat-label>Employee</mat-label>
                      <input matInput 
                            [value]="callForm.value.callId === 0 
                              ? baseService.user.firstName + ' ' + baseService.user.lastName 
                              : baseService.userLookup[callForm.value.employeeId]" 
                            readonly class="readonly-input">
                    </mat-form-field>

                    <!-- Date/Time -->
                    <mat-form-field fxFlex="40" [ngClass]="{'error': !formControlValid(callForm.controls.contactDate)}">
                      <mat-label>Date/Time</mat-label>
                      <input matInput type="datetime-local" formControlName="contactDate">
                      <mat-error *ngIf="!formControlValid(callForm.controls.contactDate)">
                        Contact date is required
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="row" style="margin-top: 5pt">
                    <div class="col-sm-12" [style.background-color]="uiData.color">
                      <span style="font-size: 12pt"><strong>Area of Inquiry</strong></span>
                    </div>
                  </div>
                  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="16px" style="margin-top: 5pt;">
                    <!-- Program -->
                    <mat-form-field fxFlex="25">
                      <mat-label>Program</mat-label>
                      <mat-select placeholder="Program" formControlName="programId">
                        <mat-option *ngFor="let program of baseService.programs" [value]="program.programId">
                          {{program.shortDescription}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>

                    <!-- Primary/Secondary/Tertiary Topics -->
                    <div formGroupName="topicForm" fxFlex="75" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="16px">
                      <mat-form-field fxFlex="33" [ngClass]="{'error' : !callTopicsValid}">
                        <mat-label>Primary Topic</mat-label>
                        <mat-select [ngStyle]="callTopicsValid ? {} : {'background-color': 'rgba(255, 0, 0, 0.3)'}" placeholder="Primary" formControlName="topic1Id" (selectionChange)="updateSecondaryTopics($event.value, isInquiry)">
                          <mat-option *ngFor="let topic of primaryTopics" [value]="topic.topicId">
                            {{topic.shortDescription}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <mat-form-field fxFlex="33" *ngIf="inquirySecondaryTopics.length > 0">
                        <mat-label>Secondary Topic</mat-label>
                        <mat-select [ngStyle]="callTopicsValid ? {} : {'background-color': 'rgba(255, 0, 0, 0.3)'}" placeholder="Secondary" formControlName="topic2Id" (selectionChange)="updateTertiaryTopics($event.value, isInquiry)">
                          <mat-option *ngFor="let topic of inquirySecondaryTopics" [value]="topic.topicId">
                            {{topic.shortDescription}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <mat-form-field fxFlex="33" *ngIf="inquiryTertiaryTopics.length > 0">
                        <mat-label>Tertiary Topic</mat-label>
                        <mat-select [ngStyle]="callTopicsValid ? {} : {'background-color': 'rgba(255, 0, 0, 0.3)'}" placeholder="Tertiary" formControlName="topic3Id" (selectionChange)="setTertiaryTopic($event.value)">
                          <mat-option *ngFor="let topic of inquiryTertiaryTopics" [value]="topic.topicId">
                            {{topic.shortDescription}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>

                  <!-- Error message for call topics -->
                  <div *ngIf="!callTopicsValid" style="margin-top: 5pt;">
                    <span class="text-danger">A call topic is required</span>
                  </div>
                  <div class="row" *ngIf="callTopics.length > 0" style="margin-top: 5pt;">
                    <div class="col-sm-12">
                      <div class="row">
                        <div class="col-sm-12" style="display: flex; justify-content: center;">
                          <table class="table table-sm table-striped" style="width: auto;">
                            <caption><strong>Selected Topics</strong></caption>
                            <tr *ngFor="let callTopic of callTopics">
                              <td>{{baseService.topicLookup[callTopic.topic1Id]}}</td>
                              <td>{{baseService.topicLookup[callTopic.topic2Id]}}</td>
                              <td>{{baseService.topicLookup[callTopic.topic3Id]}}</td>
                              <td>
                                <button mat-raised-button color="warn" (click)="deleteCallTopic(callTopic)">Delete</button>
                              </td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-2">
                    <div class="col-sm-12" [style.background-color]="uiData.color">
                      <span style="font-size: 12pt"><strong>Contact Information</strong></span>
                    </div>
                  </div>
                  <div style="margin-top: 5pt;">
                  <!-- First/Last Name -->
                  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="16px">
                    <mat-form-field fxFlex>
                      <input placeholder="First Name" formControlName="firstName" matInput />
                    </mat-form-field>
                    <mat-form-field fxFlex>
                      <input placeholder="Last Name" formControlName="lastName" matInput />
                    </mat-form-field>
                  </div>
                  <div *ngIf="possibleMatches" style="color: red; cursor: pointer; text-decoration: underline;" (click)="openPossibleMatchesSearch()">
                    {{possibleMatchResults.length}}: Possible inquiries with matching contact name found. Click here to review the matches.
                  </div>
                  &nbsp;&nbsp;
                  <!-- Address1, Address2, City, Zip -->
                  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="16px">
                    <mat-form-field fxFlex>
                      <input placeholder="Address 1" formControlName="address1" matInput />
                    </mat-form-field>
                    <mat-form-field fxFlex>
                      <input placeholder="Address 2" formControlName="address2" matInput />
                    </mat-form-field>
                    <mat-form-field fxFlex>
                      <input placeholder="City" formControlName="city" matInput />
                    </mat-form-field>
                    <mat-form-field fxFlex>
                      <input placeholder="Zip" formControlName="zipCode" matInput />
                    </mat-form-field>
                  </div>

                  <!-- State, County, Country -->
                  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="16px">
                    <mat-form-field fxFlex>
                      <mat-select placeholder="State" formControlName="stateId">
                        <mat-option *ngFor="let state of baseService.states" [value]="state.stateId">
                          {{state.stateId}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field fxFlex>
                      <mat-select placeholder="County" formControlName="countyId">
                        <mat-option *ngFor="let county of baseService.counties" [value]="county.countyId">
                          {{county.countyName}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field fxFlex>
                      <input placeholder="Country" formControlName="country" matInput />
                    </mat-form-field>
                  </div>
                  &nbsp;&nbsp;
                  <!-- Phone, Phone2, Email -->
                  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="16px">
                    <mat-form-field fxFlex>
                      <input placeholder="Phone" mask="(000) 000-0000" formControlName="phone1" matInput />
                    </mat-form-field>
                    <mat-form-field fxFlex>
                      <input placeholder="Phone 2" mask="(000) 000-0000" formControlName="phone2" matInput />
                    </mat-form-field>
                    <mat-form-field fxFlex>
                      <input placeholder="Email" formControlName="emailAddress" matInput />
                    </mat-form-field>
                  </div>
                  &nbsp;&nbsp;&nbsp;
                  <!-- Contact Types, Organization, Site Type -->
                  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="16px">
                    <mat-form-field fxFlex>
                      <mat-select placeholder="Primary Contact Type" formControlName="contactTypeId1" (selectionChange)="updateSecondaryContacts($event.value)">
                        <mat-option *ngFor="let type of primaryContacts" [value]="type.contactTypeId">
                          {{type.shortDescription}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field fxFlex *ngIf="secondaryContacts.length > 0">
                      <mat-select placeholder="Secondary Contact Type" formControlName="contactTypeId2">
                        <mat-option [value]="null">-- Select --</mat-option>
                        <mat-option *ngFor="let type of secondaryContacts" [value]="type.contactTypeId">
                          {{type.shortDescription}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field fxFlex>
                      <input placeholder="Organization" formControlName="organization" matInput />
                    </mat-form-field>
                    <mat-form-field fxFlex>
                      <mat-select placeholder="Site Type" formControlName="siteTypeId">
                        <mat-option *ngFor="let type of baseService.siteTypes" [value]="type.siteTypeId">
                          {{type.shortDescription}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <!-- Contact By, Referred By -->
                  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="16px">
                    <mat-form-field fxFlex>
                      <mat-select placeholder="Contact By" formControlName="contactMethodId">
                        <mat-option *ngFor="let method of baseService.contactMethods" [value]="method.methodId">
                          {{method.shortDescription}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field fxFlex>
                      <mat-select placeholder="Referred By" formControlName="referredById">
                        <mat-option *ngFor="let referral of baseService.referredBy" [value]="referral.referredById">
                          {{referral.shortDescription}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <!-- Notes (full width, 3 rows high) -->
                  <div fxLayout="row" style="margin-top: 16px;">
                    <mat-form-field fxFlex>
                      <textarea placeholder="Notes" formControlName="notes" matInput rows="3"></textarea>
                    </mat-form-field>
                  </div>
                </div>

                  <div class="row" style="margin-top: 5pt">
                    <div class="col-sm-12" [style.background-color]="uiData.color">
                      <span style="font-size: 12pt"><strong>Resolution</strong></span>
                    </div>
                  </div>
                  <div style="margin-top: 5pt;">
                    <!-- Action, Referred To, Status -->
                    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="16px">
                      <mat-form-field fxFlex>
                        <mat-select placeholder="Action Taken" formControlName="actionId">
                          <mat-option *ngFor="let action of baseService.actions" [value]="action.actionId">
                            {{action.shortDescription}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <mat-form-field fxFlex>
                        <mat-select placeholder="Referred To" formControlName="referredToId">
                          <mat-option *ngFor="let referral of baseService.referredTo" [value]="referral.referredToId">
                            {{referral.shortDescription}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <mat-form-field fxFlex>
                        <mat-select placeholder="Status" formControlName="statusId">
                          <mat-option *ngFor="let status of baseService.statuses" [value]="status.statusId">
                            {{status.shortDescription}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>

                    <!-- Time Spent -->
                    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="16px" style="align-items: center;">
                      <label style="margin-right: 8px; font-weight: bold;">
                        Time Spent <span class="text-danger">*</span>
                      </label>
                      <div formGroupName="timeSpentGroup" fxLayout="row" fxLayoutGap="16px" fxFlex>
                        <mat-form-field fxFlex="20">
                          <input [ngStyle]="{'background-color': !formControlValid(callForm.get('timeSpentGroup')) ? 'rgba(255, 0, 0, 0.3)' : 'transparent'}" placeholder="Hours" formControlName="hours" matInput />
                        </mat-form-field>
                        <mat-form-field fxFlex="20">
                          <input [ngStyle]="{'background-color': !formControlValid(callForm.get('timeSpentGroup')) ? 'rgba(255, 0, 0, 0.3)' : 'transparent'}" placeholder="Minutes" formControlName="minutes" matInput />
                        </mat-form-field>
                      </div>
                    </div>
                    <div *ngIf="!formControlValid(callForm.get('timeSpentGroup'))" style="margin-top: 2px;">
                      <span class="text-danger">Time spent is required</span>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div class="row" style="margin-top: 10pt; margin-bottom: 10pt" *ngIf="callForm.value.callId > 0">
        <div class="col-sm-12">
          <form [formGroup]="followupForm" (ngSubmit)="submitFollowup()">
            <div class="card">
              <div class="card card-header py-1" [style.background-color]="uiData.color">
                <strong>Follow Up Section</strong>
              </div>
              <div class="card card-body" *ngIf="callForm.value.callId > 0">
                <!-- Existing Followups Table -->
                <div *ngIf="followups.length > 0" style="margin-bottom: 16px;">
                  <table class="table table-sm" style="width: 100%;">
                    <thead>
                      <tr>
                        <th>Id</th>
                        <th>Employee</th>
                        <th>Date</th>
                        <th>Actions</th>
                        <th>Time Spent</th>
                        <th>Notes</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let followup of followups">
                        <td>{{followup.followupId}}</td>
                        <td>{{baseService.userLookup[followup.employeeId]}}</td>
                        <td>{{followup.followupDate | date:'medium'}}</td>
                        <td>{{baseService.actionLookup[followup.actionId]}}</td>
                        <td><strong>H</strong> {{Math.floor((followup.timeSpent / 60))}} : <strong>M</strong> {{followup.timeSpent % 60}}</td>
                        <td>{{followup.notes}}</td>
                        <td>
                          <button mat-raised-button color="primary" (click)="editFollowup(followup)">Edit</button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <mat-divider></mat-divider>
                </div>

                <!-- Follow Up Entry Form -->
                <div style="overflow-x:auto;">
                  <table class="table table-sm table-borderless" style="width: 100%;">
                    <thead>
                      <tr>
                        <th>Follow Up Id</th>
                        <th>Employee</th>
                        <th>Inquiry Status</th>
                        <th>Date/Time <span class="text-danger">*</span></th>
                        <th>Action Taken</th>
                        <th>Time Spent</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{{followupForm.value.followupId}}</td>
                        <td>{{baseService.userLookup[baseService.user.userId]}}</td>
                        <td>{{baseService.statusLookup[callForm.value.statusId]}}</td>
                        <td>
                          <mat-form-field style="width: 200px;">                            
                            <input matInput type="datetime-local" formControlName="followupDate">
                          </mat-form-field>                          
                        </td>
                        <td>
                          <mat-form-field>
                            <mat-select placeholder="Action Taken" formControlName="actionId">
                              <mat-option *ngFor="let action of baseService.actions" [value]="action.actionId">
                                {{action.shortDescription}}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td>
                          <div formGroupName="timeSpentGroup" fxLayout="row" fxLayoutGap="8px">
                            <mat-form-field fxFlex>
                              <input [ngStyle]="formControlValid(followupForm.get('timeSpentGroup')) ? {} : {'background-color': 'rgba(255, 0, 0, 0.3)'}" placeholder="Hours" formControlName="hours" matInput />
                            </mat-form-field>
                            <mat-form-field fxFlex>
                              <input [ngStyle]="formControlValid(followupForm.get('timeSpentGroup')) ? {} : {'background-color': 'rgba(255, 0, 0, 0.3)'}" placeholder="Minutes" formControlName="minutes" matInput />
                            </mat-form-field>
                          </div>
                          <div *ngIf="!formControlValid(followupForm.get('timeSpentGroup'))">
                            <span class="text-danger">Time spent is required</span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Notes Section -->
                <div fxLayout="row" style="margin-top: 8px;">
                  <mat-form-field fxFlex>
                    <textarea placeholder="Notes" formControlName="notes" matInput rows="3"></textarea>
                  </mat-form-field>
                </div>
              </div>
              <div class="card card-body" *ngIf="callForm.value.callId == 0">
                <span style="font-size: 14pt"><strong>Create or lookup an inquiry to add a follow up</strong></span>
              </div>
              <div class="card card-footer py-1">
                <div fxLayout="row" fxLayoutAlign="center center">
                  <button mat-raised-button color="primary" [disabled]="callForm.value.callId === 0" type="submit">
                    Save Follow Up
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      </mat-card> 
    </div>

    <mat-card *ngIf="showSearch">
        <div [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
            <div fxLayout="row wrap" fxLayoutAlign="start start">
              <form [formGroup]="searchForm" fxLayout="column" [fxFlex]="100">
                <strong class="noMarginHeader">{{searchViewMode === 'possibleMatches' ? 'Possible Matches' : 'Results'}} ({{displayedResults.length}})</strong>

                <!-- First line: all filters except topics -->
                <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="8px" fxFlex>
                  <mat-form-field fxFlex>
                    <mat-select placeholder="Program" formControlName="programId">
                      <mat-option [value]="null">-- Select --</mat-option>
                      <mat-option *ngFor="let program of baseService.programs" [value]="program.programId">
                        {{program.shortDescription}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field fxFlex>
                    <mat-label>Employee</mat-label>
                    <input matInput 
                           [(ngModel)]="selectedEmployee" 
                           [matAutocomplete]="employeeAuto" 
                           (input)="filterEmployees($any($event.target).value)"
                           [ngModelOptions]="{standalone: true}"
                           placeholder="Search employees...">
                    <mat-icon matSuffix>arrow_drop_down</mat-icon>
                    <mat-autocomplete #employeeAuto="matAutocomplete" 
                                      [displayWith]="displayEmployee" 
                                      (optionSelected)="onEmployeeSelected($event)">
                      <mat-option *ngFor="let user of filteredUsers" [value]="user">
                        {{user.lastName}}, {{user.firstName}}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>

                  <mat-form-field fxFlex>
                    <mat-select placeholder="Contact" formControlName="contactTypeId">
                      <mat-option [value]="null">-- Select --</mat-option>
                      <mat-option *ngFor="let type of primaryContacts" [value]="type.contactTypeId">
                        {{type.shortDescription}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field fxFlex>
                    <mat-select placeholder="County" formControlName="countyId">
                      <mat-option *ngFor="let county of baseService.counties" [value]="county.countyId">
                        {{county.countyName}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field fxFlex>
                    <mat-select placeholder="Status" formControlName="statusId">
                      <mat-option [value]="null">-- Select --</mat-option>
                      <mat-option *ngFor="let status of baseService.statuses" [value]="status.statusId">
                        {{status.shortDescription}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field fxFlex>
                    <input matInput [matDatepicker]="expirationStartPicker" placeholder="From" formControlName="fromDate" (keydown.enter)="submitSearch()">
                    <mat-datepicker-toggle matSuffix [for]="expirationStartPicker"></mat-datepicker-toggle>
                    <button matSuffix mat-icon-button aria-label="Clear date" (click)="searchForm.get('fromDate')?.reset()">
                      <mat-icon style="color: red;">close</mat-icon>
                    </button>
                    <mat-datepicker #expirationStartPicker></mat-datepicker>
                  </mat-form-field>

                  <mat-form-field fxFlex>
                    <input matInput [matDatepicker]="expirationEndPicker" placeholder="To" formControlName="toDate" (keydown.enter)="submitSearch()">
                    <mat-datepicker-toggle matSuffix [for]="expirationEndPicker"></mat-datepicker-toggle>
                    <button matSuffix mat-icon-button aria-label="Clear date" (click)="searchForm.get('toDate')?.reset()">
                      <mat-icon style="color: red;">close</mat-icon>
                    </button>
                    <mat-datepicker #expirationEndPicker></mat-datepicker>
                  </mat-form-field>
                </div>

                <!-- Second line: topics only -->
                <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="8px" style="margin-top: 8px;">
                  <mat-form-field fxFlex>
                    <mat-select placeholder="Primary Topic" formControlName="topicId" (selectionChange)="updateSecondaryTopics($event.value, isSearch)">
                      <mat-option [value]="null">-- Select --</mat-option>
                      <mat-option *ngFor="let topic of primaryTopics" [value]="topic.topicId">
                        {{topic.shortDescription}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field fxFlex *ngIf="searchSecondaryTopics.length > 0">
                    <mat-select placeholder="Secondary Topic" formControlName="secondTopicId" (selectionChange)="updateTertiaryTopics($event.value, isSearch)">
                      <mat-option [value]="null">-- Select --</mat-option>
                      <mat-option *ngFor="let topic of searchSecondaryTopics" [value]="topic.topicId">
                        {{topic.shortDescription}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field fxFlex *ngIf="searchTertiaryTopics.length > 0">
                    <mat-select placeholder="Tertiary Topic" formControlName="tertiaryTopicId">
                      <mat-option [value]="null">-- Select --</mat-option>
                      <mat-option *ngFor="let topic of searchTertiaryTopics" [value]="topic.topicId">
                        {{topic.shortDescription}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <!-- Third line: action buttons -->
                <div fxLayout="row wrap" fxLayoutGap="5px" fxLayoutAlign="start center" style="margin-top: 8px;">
                  <button mat-raised-button color="primary" (click)="submitSearch()">Search</button>
                  <button mat-raised-button (click)="resetFilters()">Reset Filters</button>
                  <button mat-raised-button (click)="this.showSearch = false;">
                    Return to Inquiry
                  </button>
                  <div fxFlex="1 1 auto"></div>
                  <button (click)="exportCsv()" mat-raised-button color="primary">
                    <mat-icon style="transform: rotate(270deg);">save_alt</mat-icon> Export
                  </button>
                </div>
              </form>
            </div>
            <br />

            <mat-table [dataSource]="dataSource" matSort #TableSort="matSort" class="mat-elevation-z8">
                <ng-container *ngFor="let cellData of tableDisplayData.display; let i = index" [matColumnDef]="cellData.columnName">
                    <mat-header-cell mat-sort-header *matHeaderCellDef [fxFlex]="cellData.size" [ngStyle]="isMobile ? {'width': '100%', 'padding-left': '5px'} : {}">{{cellData.displayName}}</mat-header-cell>
                    <mat-cell *matCellDef="let row" [fxFlex]="cellData.size" [ngStyle]=" isMobile ? {'width': '100%', 'padding-left': '5px'} : {}" matTooltip="{{row[cellData.columnName]}}">
                        <ng-container *ngIf="cellData.type === 'date'">
                            <ng-container>
                                <div *ngIf="isMobile" fxLayout="row">  
                                    <span><strong>{{cellData.displayName}}: </strong></span> &nbsp;
                                    <span>{{(row[cellData.columnName] | date:'MM/dd/yyyy')}}</span>
                                </div>
                                <div *ngIf="!isMobile">  
                                    {{(row[cellData.columnName] | date:'MM/dd/yyyy')}}
                                </div>                                
                            </ng-container>                         
                        </ng-container>
                        <ng-container *ngIf="cellData.type === 'lookup'">                                                                                   
                          <div *ngIf="isMobile" fxLayout="row">                                    
                            <span><strong>{{ cellData.displayName }}: </strong></span> &nbsp;
                            <span>{{ getTableDisplayLookup(row[cellData.columnName], cellData.columnName) }}</span>
                          </div>
                          <div *ngIf="!isMobile">
                            {{ getTableDisplayLookup(row[cellData.columnName], cellData.columnName) }}
                          </div>                                                          
                        </ng-container>
                        <ng-container *ngIf="cellData.type === 'topics'">                                                                                   
                          <div *ngIf="isMobile" fxLayout="row">                                    
                            <span><strong>{{ cellData.displayName }}: </strong></span> &nbsp;
                            <span>{{ getTopicDisplay(row[cellData.columnName]) }}</span>
                          </div>
                          <div *ngIf="!isMobile">
                            {{ getTopicDisplay(row[cellData.columnName]) }}
                          </div>                                                          
                        </ng-container>
                        <ng-container *ngIf="cellData.type !== 'date' && cellData.type !== 'lookup' && cellData.type !== 'topics'">                                                                
                          <div *ngIf="isMobile" fxLayout="row">                                    
                            <span><strong>{{ cellData.displayName }}: </strong></span> &nbsp;
                            <span>{{ row[cellData.columnName] }}</span>
                          </div>
                          <div *ngIf="!isMobile">
                            {{ row[cellData.columnName] }}
                          </div>                                                            
                        </ng-container>
                    </mat-cell>
                </ng-container>                     
              
                <!-- Button column -->
                <ng-container matColumnDef="actions">
                    <mat-header-cell *matHeaderCellDef [ngStyle]=" isMobile ? {'width': '100%', 'padding-left': '5px'} : {}">Actions</mat-header-cell>
                    <mat-cell *matCellDef="let row" [ngStyle]=" isMobile ? {'width': '100%', 'padding-left': '5px'} : {}">                        
                        <div *ngIf="isMobile" fxLayout="row" style="display: flex; justify-content: space-between; align-items: center;"> 
                            <span><strong>Action: </strong></span>
                            <button mat-icon-button color="primary" (click)="editInquiry(row.callId); $event.stopPropagation()">
                                <mat-icon>{{'edit'}}</mat-icon>
                            </button>
                        </div>
                        <div *ngIf="!isMobile">
                            <button mat-icon-button color="primary" (click)="editInquiry(row.callId); $event.stopPropagation()">
                                <mat-icon>{{'edit'}}</mat-icon>
                            </button>
                        </div>                        
                    </mat-cell>
                </ng-container>
                                    
                <!-- Column definitions -->
                <mat-header-row fxLayout="row" [fxHide.lt-md]="true" fxLayout.lt-md="column" *matHeaderRowDef="tableDisplayData.columns"></mat-header-row>
                <mat-row fxLayout="row" fxLayout.lt-md="column" *matRowDef="let row; index as i; columns: tableDisplayData.columns"></mat-row>
            </mat-table>
              
            <br />
            <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[10, 50, 5, searchResults.length]" #TablePaginator="matPaginator" showFirstLastButtons></mat-paginator>
        </div>              
    </mat-card>   
    </div>

    <div class="inquiry-shell__footer" *ngIf="!showSearch">
      <mat-card [style.background-color]="uiData.color" fxFlex="100">
        <div fxLayoutGap="5px" fxLayout="row">                  
          <button mat-raised-button color="primary" (click)="submitInquiry()">Save Inquiry</button>
          <button mat-raised-button (click)="openSearch()">Search</button>
          <div fxFlex [style.background-color]="'white'" *ngIf="!callTopicsValid || !formControlValid(callForm.get('timeSpentGroup'))" style="color: red; padding: 5px; border: 1px solid red; border-radius: 5px;">
            <div *ngIf="!callTopicsValid">A Topic is Required.</div>
            <div *ngIf="!formControlValid(callForm.get('timeSpentGroup'))">Time Spent is Required.</div>
          </div>
          <div fxFlex="1 1 auto"></div>
          <button mat-raised-button color="primary" (click)="newInquiry()">New Inquiry</button>                  
        </div>
      </mat-card>
    </div>
</div>